module.exports = __webpack_public_path__ + "img/jyzl.988de8d6.jpg";